"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _Severity = _interopRequireDefault(require("../constants/Severity"));

var EventData = function EventData(alarms) {
  (0, _classCallCheck2.default)(this, EventData);
  var aboveNav = [];
  var belowNav = [];
  this.alarms = alarms;
  this.groupedAlarms = alarms.reduce(function (map, alarm) {
    var alarmSeverity = alarm.severity.key;
    map[alarmSeverity] = map[alarmSeverity] || [];

    if (alarm.severity === _Severity.default.CRITSIT) {
      aboveNav.push(alarm);
    } else {
      belowNav.push(alarm);
    }

    map[alarmSeverity].push(alarm);
    return map;
  }, {});
  this.placement = {
    aboveNav: aboveNav,
    belowNav: belowNav
  };
};

var _default = EventData;
exports.default = _default;
module.exports = exports.default;